(function () {
	'use strict';

	angular.module('dcApp').controller('MonitoringController', [
		'MonitoringServices',
		'$scope',
		'$rootScope',
		'$stateParams',
		'ContextServices',
		'$window',
		'permissionChecker',
		'AppSelectorService',
		function (
			MonitoringServices,
			$scope,
			$rootScope,
			$stateParams,
			ContextServices,
			$window,
			permissionChecker,
			AppSelectorService
		) {
			$scope.loadData = false;

			var initMonitoring = function () {
				$scope.showBackend = true;
				$scope.showSpark = true;
				if ($stateParams.ctx !== undefined) {
					$scope.showBackend = false;
					$scope.context = $stateParams.ctx;
				} else if (AppSelectorService.getSelectedCtxId() > -1) {
					$scope.context = AppSelectorService.getSelectedCtxId();
				} else if ($scope.contextList && $scope.contextList[0]) {
					$scope.context = $scope.contextList[0].id
				} else {
					return;
				}

				$scope.loadData = true;

				var conxt = _.find($scope.contextList, function (item) {
					return item.id == $scope.context;
				});

				if (!conxt) {
					return;
				}

				$scope.contextName = conxt.lib;
			};

			var init = function () {
				ContextServices.getContextList(true).then(function (response) {
					$scope.contextList = response.data;
					initMonitoring();
				});
			};

			permissionChecker.checkGlobalPermission(
				'metrics',
				function () {
					init();
				},
				function () {
					$scope.metrics_unauthorised = true;
				}
			);
		},
	]);
})();
